var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}import React, { useRef, useState, useCallback, useEffect } from 'react';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import rison from 'rison-node';
import { Icon } from "../../UI";
import { I18NLink, t } from "../../I18N";
import { wrapDispatch } from "../../Multireducer";


import { useOnClickOutsideElement } from "../../utils/useOnClickOutsideElementHook";
import { encodeSearch } from "../actions/libraryActions";
import {
getCurrentSortOption,
getPropertySortType,


filterTemplates,
getSortOptions } from "../helpers/sortComponets";






const getOptionUrl = (location, option, path) => {
  const currentQuery = rison.decode(decodeURIComponent(location.query.q || '()'));
  const type = getPropertySortType(option);
  return `${path}${encodeSearch(_objectSpread(_objectSpread({},
  currentQuery), {}, { order: type === 'string' ? 'asc' : 'desc', sort: option.value }),
  true)
  }`;
};

const mapStateToProps = (state, ownProps) => {
  let { templates } = state;

  if (ownProps.selectedTemplates && ownProps.selectedTemplates.count()) {
    templates = filterTemplates(state.templates, ownProps.selectedTemplates);
  }

  return {
    templates,
    locale: state.locale
  };
};

const mapDispatchToProps = (dispatch) =>
bindActionCreators({ merge: actions.merge }, wrapDispatch(dispatch, 'library'));

const connector = connect(mapStateToProps, mapDispatchToProps);



const SortDropdownComponent = ({ templates, location, locale }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const menuRef = useRef(null);

  const currentQuery = rison.decode(decodeURIComponent(location.query.q || '()'));
  const path = location.pathname.replace(new RegExp(`^/?${locale}/|^/?${locale}$`), '');
  const sortButtonLink = `${path}${encodeSearch(_objectSpread(_objectSpread({},
  currentQuery), {}, { order: currentQuery.order === 'asc' ? 'desc' : 'asc' }),
  true)
  }`;

  useEffect(() => {
    setDropdownOpen(false);
  }, [currentQuery.sort]);

  useOnClickOutsideElement(
  menuRef,
  useCallback(() => {
    setDropdownOpen(false);
  }, []));


  const sortOptions = getSortOptions(currentQuery, templates);

  return /*#__PURE__*/(
    _jsx("div", { className: "sort-buttons" }, void 0, /*#__PURE__*/
    React.createElement("div", { className: "sort-dropdown", ref: menuRef }, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: `dropdown-button ${dropdownOpen ? 'expanded' : ''}`,
      onClick: () => setDropdownOpen(!dropdownOpen) }, void 0, /*#__PURE__*/

    _jsx("span", {}, void 0, getCurrentSortOption(sortOptions, currentQuery.sort)), /*#__PURE__*/
    _jsx(Icon, { icon: dropdownOpen ? 'caret-up' : 'caret-down' })), /*#__PURE__*/


    _jsx("ul", { className: `dropdown-menu ${dropdownOpen ? 'expanded' : ''}` }, void 0,
    sortOptions.map((option) => {
      const url = getOptionUrl(location, option, path);
      return /*#__PURE__*/(
        _jsx("li", {}, option.value, /*#__PURE__*/
        _jsx(I18NLink, { to: url, href: url }, void 0,
        option.label)));



    }))), /*#__PURE__*/



    _jsx(I18NLink, {
      to: sortButtonLink,
      href: sortButtonLink,
      disable: currentQuery.sort === '_score' ? 'true' : undefined }, void 0, /*#__PURE__*/

    _jsx("button", {
      type: "button",
      disabled: currentQuery.sort === '_score' ? true : undefined,
      onClick: () => {},
      className: "sorting-toggle" }, void 0, /*#__PURE__*/

    _jsx("span", { style: { display: 'none' } }, void 0,
    currentQuery.order === 'asc' ?
    t('System', 'Sort descending', undefined, false) :
    t('System', 'Sort ascending', undefined, false)), /*#__PURE__*/

    _jsx(Icon, {
      icon:
      currentQuery.order === 'asc' && currentQuery.sort !== '_score' ?
      'arrow-up' :
      'arrow-down' })))));






};

const container = withRouter(connector(SortDropdownComponent));
export { container as SortDropdown };